import "./sectionTitle.css";

type Props = {
  title: string;
  className?: string;
  align?: "left" | "center";
};

export const SectionTitle = ({
  title,
  className = "",
  align = "center",
}: Props) => {
  return (
    <div className={`oc-sectionTitle oc-sectionTitle--${align} ${className}`}>
      <h2 className="oc-sectionTitle__h2">{title}</h2>
    </div>
  );
};
